<script setup>
import SiteContent from '#/layout/components/SiteContent.vue'
import SiteFooter from '#/layout/components/SiteFooter.vue'
import SiteHeader from '#/layout/components/SiteHeader.vue'
import AlertCookie from '@/libvue/components/alert/Cookie.vue'
import SkipNav from '@/libvue/components/skipnav/SkipNav.vue'
</script>

<template>
  <div id="rcMainWrapper" class="rc-wrapper rc-default-layout" tabindex="-1">
    <AlertCookie />
    <SkipNav />
    <SiteHeader />
    <SiteContent />
    <SiteFooter />
  </div>
</template>
